import UserPickStructure from "../../Constants/UserPickStructure"; // Adjust path as needed

export const fetchUPFeedData = async (userId) => {
  try {
    const response = await fetch(
      // `/api/mock/UserPick/UserPickMockData_${userId.toLowerCase()}.json`
      `/api/mock/UserPickData/UserPickMockData_spadhy.json`
    );

    if (!response.ok) {
      throw new Error(`File not found for userId: ${userId}`);
    }

    const data = await response.json();

    // ✅ Format according to UserPickStructure
    const formattedData = {
      ...UserPickStructure,
      userId: data.userId || "",
      userName: data.userName || "",
      profileImage: data.profileImage || "",
      lastUpdatedOn: data.updated || data.lastUpdatedOn || "",
      location: data.userLocation || data.location || "",
      createdOn: data.createdOn || "",
      lastActive: data.lastActive || "",
      status: data.status || "",
      nBlueTickFollowing: data.nBlueTickFollowing || "",
      feeds: (data.feeds || []).map((feed) => ({
        userId: feed.userId || "",
        userUUID: feed.userUUID || "",
        userImageUrl: feed.userImageUrl || "",
        userName: feed.userName || "",
        BlueTickStatus: feed.BlueTickStatus || "",
        profile: feed.profile || "",
        location: feed.location || "",
        posts: (feed.posts || []).map((post) => ({
          postId: post.postId || "",
          descriptions: post.descriptions || post.description || "",
          timestamp: post.timestamp || "",
          location: post.location || "",
          nlikes: post.nlikes || 0,
          medias: (post.medias || []).map((media) => ({
            mediatype: media.mediatype || "",
            mediaurl: media.mediaurl || "",
            nlikes: media.nlikes || 0,
            comments: (media.comments || []).map((comment) => ({
              userId: comment.userId || "",
              comment: comment.comment || "",
              timestamp: comment.timestamp || "",
              location: comment.location || ""
            })),
            nshares: media.nshares || 0,
            nsuggests: media.nsuggests || 0
          })),
          comments: (post.comments || []).map((comment) => ({
            userId: comment.userId || "",
            comment: comment.comment || "",
            timestamp: comment.timestamp || "",
            location: comment.location || ""
          })),
          nshares: post.nshares || 0
        }))
      }))
    };

    return formattedData;
  } catch (error) {
    console.error(`❌ Failed to fetch mock user pick data for "${userId}":`, error);
    return null;
  }
};

export default fetchUPFeedData;
